import { Car, UserPlus, Wrench } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
const servicesData = [{
  title: "Artisanal Pastries",
  description: "Delicate, flaky croissants and traditional Albanian sweets baked fresh every morning with premium butter and local fruits.",
  icon: Car
}, {
  title: "Specialty Coffee",
  description: "Expertly roasted beans and precision brewing techniques that capture the aromatic essence of the Mediterranean coast.",
  icon: UserPlus
}, {
  title: "Signature Cocktails",
  description: "Refreshing infusions and tropical blends designed for Saranda sunsets, featuring local herbs and premium spirits.",
  icon: Wrench
}];
export default function Services() {
  return <section data-section-id="224847" id="our-craft-cravings" className="w-full bg-background py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center">
          <h2 className="font-default text-3xl font-bold text-foreground md:text-5xl tracking-tight">
            Our Craft & Cravings
          </h2>
        </div>
        
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {servicesData.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className="group rounded-lg border border-border bg-card transition-all duration-500 hover:-translate-y-2 hover:border-primary/30 hover:shadow-xl overflow-hidden">
                <CardHeader className="pb-4">
                  <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-secondary text-primary transition-transform duration-500 group-hover:scale-110">
                    <Icon className="h-6 w-6" />
                  </div>
                  <CardTitle className="font-default text-2xl font-bold text-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="font-sans text-base leading-relaxed text-muted-foreground">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}